import type { PixelAssociatedEntity } from 'sonata-static-storage/lib/schemas/pixel/pixel.schema';
import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

export function getConversionTrackingTags(pixels: PixelAssociatedEntity[] | undefined): TagItem[] {
  const count = pixels?.length ?? 0;
  if (count === 0) {
    return [];
  }

  return [{ label: `${count} pixel${count !== 1 ? 's' : ''}` }];
}
